import { PREPARE_TREATMENT_FILES } from '../set-and-shop-scan/task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'

export default createUIDefinition({
    taskName:PREPARE_TREATMENT_FILES,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.SENT_EMAIL_WIDGET,
        },
        {
            component: processUI.INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.PAYMENT_LIST_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
        {
            component: processUI.TECHNICAL_LOG_CONTAINER,
        },
    ]
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/prepare-treatment-files.js